import { ISistema } from "../interface-system/system-interface";
import { AlterSituacaoEnum, SituacaoRestricEnumRegistro, PerfilRestrictEnumRegistro, EnumPadrao } from "../enums/Enumarations";
import { Router, ActivatedRoute } from "@angular/router";
import { PadraoService } from "../../../service/padrao.service";
import { ObservableLotacao, bObservableUsuario } from "../../../util/observable-util";
import { ConfirmationService, Message } from "primeng/primeng";
/**
 * Implementação Base da interface ISistema deve ser extendida para as classes de sistemas filhas
 */
export class BaseImplemantation implements ISistema {
    /**
     * Construtor do sistema registro, esse construtor deve possuir os mesmos dados usados na interface SistemaConstrutor
     */
    constructor(
        public router: Router,
        public activatedRoute: ActivatedRoute,
        public service: PadraoService,
        public confirmacao: ConfirmationService,
        public msgs: Message[],
        public bObservable: bObservableUsuario
    ) { };
    perfilLotado: any = EnumPadrao;
    situacaoAlter: any = EnumPadrao;
    perfilRestrict: any = EnumPadrao;
    situacaoRestric: any = EnumPadrao;
    variableComparable: any = EnumPadrao;
    componentsAppMenu: any[]= [];
    /**
     * Método a ser usado para inicializar variaveis e outros nas classes filhas.
     */
    init() { };
    /**
     * Inicia o observable, assim sempre que atualizar o observable a variavel perfilLotado irá alterar de acordo.
     */
    ngOnInit() {

        this.bObservable.getValue.subscribe(lotacao => {
            if (lotacao)
                this.perfilLotado = lotacao.obj.lotacaoDTO[0].perfilDTO[0].nome
        });
        this.init();
    }

    undefinedMethod(value1?: any, value2?: any, value3?: any, value4?: any, value5?: any, value6?: any, value7?: any, value8?: any, value9?: any, value10?: any) { };

    dataTableFunction(event?: any, controllerName?: any, filtro?: any, situacao?: any, listagem?: any,
        value6?: any, value7?: any, value8?: any, value9?: any, value10?: any) { }

    showMsg(severity: string, summary: string, detail: string) {
        this.msgs.push({ severity: severity, summary: summary, detail: detail });
    }

    /**
     * NÃO ALTERAR ESSE MÉTODO! 
     * Servico de validacao padrao para todos os sistemas, caso seja necessário implementar no objeto filho e criar as restrições de acordo com a necessidade.
     * @param situacao 
     */
    validAction(situacao: number): any {
        if (this.situacaoRestric[situacao] != undefined) {
            this.showMsg('warn', 'Mensagem de Alerta', this.situacaoRestric[situacao]);
            return false;
        } else if (this.situacaoRestric[situacao] == undefined && this.perfilRestrict[this.perfilLotado] != undefined) {
            this.showMsg('warn', 'Mensagem de Alerta', this.perfilRestrict[this.perfilLotado]);
            return false;
        } else if (this.situacaoRestric[situacao] == undefined && this.perfilRestrict[situacao] == undefined) {
            return true;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/base/use-system/implementation-system/base-system-implementation.ts